export default __webpack_public_path__ + "files/c777f217b313b752b9013b830b41aaf9.mp3";